import React from 'react';
import './Education.css';
import unoLogo from '../assets/uno_logo.png';
import sustLogo from '../assets/sust_logo.png';

const EDUCATION_ITEMS = [
  {
    school: 'University of Nebraska Omaha',
    shortName: 'UNO',
    location: 'Omaha, NE, USA',
    degree: 'Ph.D. in Computing & Information Science',
    dates: 'Aug. 2022 – Present',
    note: 'Doctoral research in AI-driven communication systems and autonomous cyber-physical platforms.',
    logo: unoLogo,
  },
  {
    school: 'University of Nebraska Omaha',
    shortName: 'UNO',
    location: 'Omaha, NE, USA',
    degree: 'M.Sc. in Computer Science',
    dates: 'Aug. 2022 – Dec. 2024',
    note: 'Graduate study in computing, networking, and systems-oriented machine learning.',
    logo: unoLogo,
  },
  {
    school: 'Shahjalal University of Science and Technology',
    shortName: 'SUST',
    location: 'Sylhet, Bangladesh',
    degree: 'B.Sc. in Computer Science and Engineering',
    dates: 'Apr. 2014 – Oct. 2018',
    note: 'Undergraduate foundation in computer science, software engineering, and systems thinking.',
    logo: sustLogo,
  },
];

function Education() {
  return (
    <section id="education" className="site-section" aria-labelledby="education-heading">
      <div className="site-section-inner">
        <div className="section-heading">
          <p className="section-kicker">Education</p>
          <h2 id="education-heading" className="section-title">Academic Training</h2>
          <p className="section-intro">
            Formal training across computer science, information systems, and
            research-led work in intelligent networking and cyber-physical systems.
          </p>
        </div>

        <div className="education-grid">
          {EDUCATION_ITEMS.map((item) => (
            <article key={`${item.school}-${item.degree}`} className="education-card card-surface">
              <div className="education-card-top">
                <img src={item.logo} alt={`${item.shortName} logo`} className="education-logo" />
                <div>
                  <h3>{item.degree}</h3>
                  <p className="education-school">{item.school}</p>
                </div>
              </div>
              <p className="eyebrow-chip education-meta">{item.location}</p>
              <p className="education-dates">{item.dates}</p>
              <p className="education-note">{item.note}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Education;
